import React from 'react';
import PropTypes from 'prop-types';
import { FormattedDecimal } from '~/modules/common/components/Decimal';

export const HoursValue = ({
  className,
  value,
  numberFormat,
  fixedDecimalScale = true
}) => {
  return (
    <FormattedDecimal
      className={className}
      value={value}
      fixedDecimalScale={fixedDecimalScale}
      numberFormat={numberFormat}
    />
  );
};

HoursValue.propTypes = {
  className: PropTypes.string,
  value: PropTypes.number,
  numberFormat: PropTypes.object,
  fixedDecimalScale: PropTypes.bool
};

export default HoursValue;
